<template>
    <div class="flex-row middle box-panel wf left start">
        <div class="img-box">
            <img :src="$matrix.GetImageSrc(config.Type, 'icons')" alt="" :style="imgStyle" />
        </div>
        <div class="flex-column list" style="padding: 10px">
            <div class="table-cell">
                <span class="c-gray-bold fnumber"> {{ value }}</span>
            </div>
            <div class="c-gray">{{ config.Title }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Number,
        config: Object,
    },
    computed: {
        imgStyle() {
            return { width: "36px", height: "36px", margin: "0 auto" };
        },
    },
    methods: {
        
    },
};
</script>

<style scoped>
.box-panel {
    background: #fff;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 10px;
}

.c-gray {
    color: #909399;
}

.c-gray-bold {
    color: #49494b;
    font-weight: bold;
}

.fnumber {
    font-size: 30px;
}

.table-cell {
    display: table-cell;
    vertical-align: bottom;
}

.img-box {
    background: #f3f3f1;
    border-radius: 10px;
    width: 60px;
    height: 60px;
    text-align: center;
    align-items: center;
    display: flex;
    margin-right: 20px;
}
</style>